<template>
    <ModalDefaultInner
        v-model="showTrialModal"
        :modal-data="modalTrialData"
        @cta="goToPricingPage"
        @close="close"
    >
        <template #icon>
            <CardIcon type="success">
                <PadlockKeyIcon />
            </CardIcon>
        </template>

        <ul class="mt-5 pl-6 list-disc space-y-3">
            <li>
                {{ $t("shared.trial_modal.point1") }}
            </li>
            <li>
                {{ $t("shared.trial_modal.point2") }}
            </li>
            <li>
                {{ $t("shared.trial_modal.point3") }}
            </li>
            <li>
                {{ $t("shared.trial_modal.point4") }}
            </li>
            <li>
                {{ $t("shared.trial_modal.point5") }}
            </li>
        </ul>
    </ModalDefaultInner>
</template>

<script>
import { i18n } from "@/i18n";
import { CardIcon } from "@easy/ui/cards";
import { PadlockKeyIcon } from "@easy/ui/icons";
import { ModalDefaultInner } from "@easy/ui/modals";

export default {
    components: {
        ModalDefaultInner,
        CardIcon,
        PadlockKeyIcon,
    },
    props: {
        modalData: Object,
    },
    emits: ["close"],
    data() {
        return {
            showTrialModal: false,
        };
    },
    computed: {
        modalTrialData() {
            return {
                title: this.$t("shared.trial_modal.title"),
                description: this.$t("shared.trial_modal.subtitle"),
                ctaLabel: this.$t("shared.trial_modal.cta"),
            };
        },
    },
    methods: {
        goToPricingPage() {
            const lang = i18n.global.locale.value;
            const pricingLink = `https://easy.tools/${lang === "pl" ? "pl/cennik" : "pricing"}?ref=app`;
            window.location.href = pricingLink;
            this.showTrialModal = false;
            this.$emit("close");
        },
        close() {
            this.$emit("close");
        },
    },
};
</script>
